export default function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
